// Import des styles SCSS (si nécessaire)
// import '../scss/app.scss';

import { initPhotoSwipe } from './components/photoswipe';
import { initHeaderScroll } from './components/header-scroll';

document.addEventListener("DOMContentLoaded", () => {
    initPhotoSwipe();
    // initHeaderScroll();
});
